const AutoFilledIndicator = ({ isAutoFilled }: { isAutoFilled: boolean }) => {
  if (isAutoFilled)
    return (
      <span className="my-[3px] ml-3 h-2 w-2 rounded-full bg-[#F2994A]" style={{ display: 'inline-block' }}></span>
    );
  return null;
};

export default AutoFilledIndicator;
